/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$state','$translate', '$timeout', 'Auth', 'LoginService', 'DataUtils', '$scope', 'ProfileService', 'DateUtils'];

    function RegisterController ($state, $translate, $timeout, Auth, LoginService, DataUtils, $scope, ProfileService, DateUtils) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.errorIban = null;
        vm.errorBic = null;
        vm.errorWrongFormat = null;
        vm.errorMaxUploadSize = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.fileSize = null;
        vm.registerAccount.captcha = null;
        $scope.$state = $state;
        vm.welcomeFee = null;
        vm.anualFee = null;
        vm.toPay = null;
        vm.calcToPay = calcToPay;
        vm.showFreeYear = false;
        vm.selectMemberStatus = selectMemberStatus;
        vm.university = false;

        $timeout(function (){angular.element('#firstName').focus();});

        init();

        function init() {
            var d = new Date();
            var n = d.getMonth();
            if(n === 10 || n === 11) {
                vm.showFreeYear = true;
            }
            vm.calcToPay();
        }

        function calcToPay() {
            ProfileService.getProfileInfo().then(function(response) {
                vm.welcomeFeeStudent = response.welcomeMembershipFeeStudent;
                vm.welcomeFeeNormal = response.welcomeMembershipFeeStudentNormal;
                vm.welcomeFee = vm.registerAccount.profile.isStudent ? vm.welcomeFeeStudent : vm.welcomeFeeNormal;
                vm.anualFee = response.anualMembershipFee;
                vm.toPay = vm.welcomeFee + vm.anualFee;
            });
        }

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else if(vm.registerAccount.captcha === null) {
                console.log("captcha?");
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;
                vm.errorBic = null;
                vm.errorIban = null;
                if (vm.registerAccount.profile.nickname) {
                    vm.registerAccount.profile.nickname = vm.registerAccount.profile.nickname.trim();
                }
                if (vm.registerAccount.profile.nickname === vm.registerAccount.firstName) {
                    vm.registerAccount.profile.nickname = null;
                }
                if (!vm.university && !vm.registerAccount.profile.isStudent) {
                    vm.registerAccount.profile.university = null;
                }
                if (vm.registerAccount.profile.isUsingSepa === true) {
                    if(vm.registerAccount.profile.isDeviatedHolder === false) {
                        vm.registerAccount.profile.bankAccountHolder = vm.registerAccount.firstName + ' ' + vm.registerAccount.lastName;
                    }
                } else {
                    vm.registerAccount.profile.bankAccountHolder = null;
                    vm.registerAccount.profile.iban = null;
                    vm.registerAccount.profile.bic = null;
                    vm.registerAccount.profile.isDeviatedHolder = false;
                }

                var copy = angular.copy(vm.registerAccount);
                copy.profile.birthdate = DateUtils.convertLocalDateToServer(copy.profile.birthdate);

                Auth.createAccount(copy).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'bic') {
                        vm.errorBic = 'ERROR';
                    } else if (response.status === 400 && response.data === 'iban') {
                        vm.errorIban = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }

        vm.datePickerOpenStatus.birthdate = false;

        vm.truncateUpload = function() {
            vm.registerAccount.profile.matriculationCertificate = null;
            vm.registerAccount.profile.matriculationCertificateContentType = null;
            vm.errorWrongFormat = false;
            vm.errorMaxUploadSize = false;
        };

        vm.truncateBancAccount = function() {
            vm.registerAccount.profile.iban = null;
            vm.registerAccount.profile.bic = null;
            vm.registerAccount.profile.bankAccountHolder = null;
            vm.registerAccount.profile.isDeviatedHolder = false;
        };

        vm.truncateBancAccountHolder = function() {
            vm.registerAccount.profile.bankAccountHolder = null;
        };

        vm.setMatriculationCertificate = function ($file, profile) {
            if ($file) {
                if ($file.type !== 'application/pdf') {
                    vm.errorWrongFormat = true;
                } else {
                    DataUtils.toBase64($file, function(base64Data) {
                        vm.fileSize = vm.byteSize(base64Data).replace(/\s/g, '').replace('bytes', '');
                        if (vm.fileSize > 2097152) {
                            $scope.$apply(function() {
                                vm.errorMaxUploadSize = true;
                            });
                        } else {
                            $scope.$apply(function() {
                                profile.matriculationCertificate = base64Data;
                                profile.matriculationCertificateContentType = $file.type;
                                vm.errorWrongFormat = false;
                                vm.errorMaxUploadSize = false;
                            });
                        }
                    });
                }
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $scope.setResponse = function (response) {
            // send the `response` to your server for verification.
            console.log(response);
            vm.registerAccount.captcha = response;
        };

        $scope.cbExpiration = function() {
            // reset the 'response' object that is on scope
            console.log("expired");
            vm.registerAccount.captcha = null;
        };

        function selectMemberStatus() {
            if(vm.registerAccount.profile.memberStatus === 'gast') {
                vm.registerAccount.profile.isUsingSepa = false;
                vm.registerAccount.profile.isStudent = false;
            } else {
                vm.registerAccount.profile.isUsingSepa = true;
                vm.registerAccount.profile.isStudent = false;
            }
        }
    }
})();
